<template>
  <el-autocomplete v-model="keyword" :fetch-suggestions="querySearchAsync"
    :placeholder="$t('common.pleaseEnterYourName')" value-key="guestName" :trigger-on-focus="false" :maxlength="20"
    clearable @select="handleSelect" @clear="clear" @blur="handleBlur" v-bind="$attrs"
    :popper-class="type === 'booking' ? 'booking' : 'checkIn'">
    <template slot-scope="{ item }">
      <p class="flex-center">
        <span class="card-span" :title="item.guestName.length > 3 ? item.guestName : ''">
          {{ item.guestName.slice(0, 3) }}
          <template v-if="item.guestName.length > 3"><label style="margin-left: -3px">...</label></template>
        </span>
        <template v-if="type === 'booking'">{{ item.guestPhone }}</template>
        <template v-else>{{ item.documentNumber }}</template>
      </p>
    </template>
  </el-autocomplete>
</template>
<script>
import { autocompleteNameOrMobileOrDocNo } from '@/api/realTime'
export default {
  name: 'BaseAutocomplete',
  inheritAttrs: false,
  model: {
    prop: 'bingValue',
    event: 'valueChange'
  },
  props: {
    bingValue: {
      type: String,
      default: ''
    },
    dataSource: {
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
      type: String,
      default: 'checkin' // checkin入住、booking预订、member会员
    }
  },
  data() {
    return {
      restaurants: [],
      timeout: null
    };
  },
  computed: {
    keyword: {
      get() {
        return this.bingValue
      },
      set(value) {
        this.$emit('valueChange', (value || '').replace(/^\s+/, ''))
      }
    }
  },
  created() {
    //this.input();
  },
  methods: {
    querySearchAsync(queryString, cb) {
      clearTimeout(this.timeout);
      if (this.isAllNumber(queryString) && queryString.length < 3) {
        cb([])
        return
      }
      this.timeout = setTimeout(async () => {
        cb(await this.autocompleteSearch(queryString));
      }, 500);
    },
    autocompleteSearch(queryString) {
      return new Promise(resolve => {
        autocompleteNameOrMobileOrDocNo({
          [this.getQueryKey(queryString)]: queryString,
          sourcerList: this.getSourceList()
        }).then(res => {
          if (res.code === '0') {
            resolve(res.data)
          }
        }).catch(() => {
          resolve([])
        })
      })
    },
    // 点击清除
    clear() {
      this.$emit('valueChange', '')
    },
    handleBlur() {
      this.$emit('valueChange', (this.bingValue || '').trim())
    },
    handleSelect(item) {
      this.$emit('select', item)
      const {
        guestName: roomGuestName,
        guestPhone: roomGuestTelephone,
        documentType: roomGuestDocumentType,
        singleDocumentType,
        documentNumber: roomGuestDocumentNumber,
        sex: roomGuestSex,
        birthday: roomGuestBirthday,
        nation: roomGuestCountry,
        nationGroup: roomGuestNation,
        address: roomGuestAddress,
        dialingCode: dialingCode
      } = item
      const assignObj = {
        roomGuestName,
        roomGuestTelephone,
        roomGuestDocumentNumber
      }
      if (this.type === 'booking') { // 预订的话只取姓名与手机号
        Object.assign(this.dataSource, {
          bookerName: roomGuestName,
          bookerTelephone: roomGuestTelephone,
          dialingCode: dialingCode
        })
      } else if (this.type === 'member') { // 单点会员
        Object.assign(this.dataSource, {
          memberName: roomGuestName,
          mobile: roomGuestTelephone,
          idType: singleDocumentType,
          idNo: roomGuestDocumentNumber,
          sex: roomGuestSex,
          birthday: roomGuestBirthday,
          address: roomGuestAddress,
          dialingCode: dialingCode
        })
      } else {
        Object.assign(this.dataSource, {
          roomGuestName,
          roomGuestTelephone,
          roomGuestDocumentType,
          roomGuestDocumentNumber,
          roomGuestSex,
          roomGuestBirthday,
          roomGuestCountry,
          roomGuestNation,
          roomGuestAddress,
          dialingCode
        })
      }
    },
    getQueryKey(str) {
      switch (this.type) {
        case 'checkin':
          return this.isAllNumber(str) ? 'documentNumber' : 'guestName';
        default:
          return this.isAllNumber(str) ? 'guestPhone' : 'guestName'
      }
    },
    getSourceList() {
      if (this.type === 'member') {
        return [3]
      } else if (this.type === 'checkin') {
        return [1, 3]
      }
      return [1, 2, 3]
    },
    isAllNumber(str) {
      return /[0-9]+/.test(str)
    },
  }
}
</script>
<style lang="scss" scoped>
.card-span {
  display: inline-block;
  width: 56px;
  white-space: nowrap;
  margin-right: 10px;
}
</style>
<style lang="scss">
.el-popper {
  &.booking {
    width: 200px !important;

    .el-autocomplete-suggestion__wrap {
      max-height: 200px;
    }
  }

  &.checkIn {
    width: 240px !important;

    .el-autocomplete-suggestion__wrap {
      max-height: 200px;
    }
  }
}
</style>
